import request from '../utils/request'

export function arsActivityOrderActivityRecordApi (data) {
  return request({
    url: 'api/activityOrder/activityRecord',
    method: 'post',
    data
  })
}

export function activityOrderInfoApi (orderId) {
  return request({
    url: `api/activityOrder/info/${orderId}`,
    method: 'get'
  })
}

export function activityEmployeeIntegralListApi () {
  return request({
    url: 'api/activityEmployee/integralListPage',
    method: 'get'
  })
}
